/* eslint-disable react-hooks/exhaustive-deps */
import "./ArticlePage.scss";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from "../../components/ui/Container/Container";
import { useDispatchedActions } from "../../hooks";
import { ApiService } from "../../services/ApiService";
import { ContentReducerActions } from "../../redux/reducers/ContentReducer/Content.reducer";
import { HeaderReducerActions } from "../../redux/reducers/HeaderReducer/Header.reducer";
import { BlogCategory } from "../BlogPage/components/BlogCategory/BlogCategory";
import { Article } from "./components/Article/Article";

const ArticlePage = () => {
  const { lang, articleId } = useParams();
  const { blog: { article, groups } } = useSelector((state) => state.content);
  const { setBlogArticle } = useDispatchedActions();

  // eslint-disable-next-line max-statements-per-line
  const redirectToBlog = () => { window.location.href = `/${lang}/blog`; };

  const articleGroupTag = article?.groups?.length && article.groups[0].tag;
  const groupByLocale = groups[lang] || [];
  const currentGroup = groupByLocale.find(({ groupTag }) => groupTag === articleGroupTag);

  const relatedArticles = currentGroup?.articles
    .filter((article) => article.tag !== articleId)
    .slice(0, 3) || [];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [article]);

  useEffect(() => {
    const articleTagByLang = article?.tagByLocale?.[lang];

    if (!articleTagByLang) {
      redirectToBlog();
      return;
    }

    if (articleId === articleTagByLang) return;

    window.location.href = `/${lang}/blog/${articleTagByLang}`;

  }, [lang]);

  useEffect(() => () => setBlogArticle(null), []);

  if (!article) {
    redirectToBlog();
    return;
  }

  return (
    <div className="article-page">
      <Container>
        <Article article={article} />
        {!!relatedArticles?.length && (
          <div className="article-page__related">
            <h2>{lang === "en" ? "Related articles" : "Похожие статьи"}</h2>
            <BlogCategory group={{ articles: relatedArticles }}/>
          </div>
        )}
      </Container>
    </div>
  );
};

ArticlePage.getServerSideState = async (store, params) => {
  const baseURL = process.env.REACT_APP_SSR_API_URL;

  const { data } = await ApiService.getBlogArticleSSR(baseURL, params.locale, params.params.articleId);

  store.dispatch(ContentReducerActions.setBlogArticle(data));
  store.dispatch(HeaderReducerActions.setDarckTheme(params.theme));
};

export default ArticlePage;
